'use strict';

import $ from 'jquery';

let accAdditionalInfo = $('.field--name-field-additional-info-title');
accAdditionalInfo.on('click', function() {
  $(this).toggleClass('expanded');
  $(this).siblings('.field--name-field-additional-info-body').stop(true).slideToggle(300);
});

let accActor = $('.field--name-field-actor-item-title');
accActor.on('click', function() {
  $(this).toggleClass('expanded');
  $(this).siblings('.field--name-field-actor-taxonomy-reference').stop(true).slideToggle(300);
});

var accordionTitles = $('.field--name-field-acc-title, .webform-section-accordion');
$(document).ready(function () {
  accordionTitles.each(function (idx, accordionTitle){
    $(accordionTitle).attr('tabindex', '0');
  });
});

accordionTitles.each(function (idx, accordionTitle){
  accordionTitle.iframe = $(accordionTitle).parent().find('iframe.async-loading');

  $(accordionTitle).on('click', function () {
    $(this).toggleClass('expanded');
    $(this).next().stop().slideToggle(300);

    if ($(accordionTitle.iframe).length && $(accordionTitle.iframe).attr('src') == '') {
      $(accordionTitle.iframe).attr('src', $(accordionTitle.iframe).attr('data-url'));
    }
  });

  $(accordionTitle).on('keydown', function (e) {
    var keyCode = e.keyCode || e.which;

    if (keyCode === 13) {
      e.preventDefault();
      $(e.target).trigger('click');
    }
  });
});

$(document).ready(function () {
  var iframeOutsideAccordions = $('iframe.async-loading').not('.field--name-field-acc-contents iframe').not('.webform-section-accordion iframe');
  iframeOutsideAccordions.each(function (idx, iframeOutsideAccordion){
    if (iframeOutsideAccordions.length && $(iframeOutsideAccordion).attr('src') == '') {
      $(iframeOutsideAccordion).attr('src', $(iframeOutsideAccordion).attr('data-url'));
    }
  });
});
